'use strict';

import styled from 'styled-components';

export const MenuStyled = styled.div`
  width: 100%;
  min-width: 0;
  flex-shrink: 0;
`;

MenuStyled.displayName = 'MenuStyled';




// WEBPACK FOOTER //
// ./src/app/components/Menu/styles/MenuStyled.js